<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      edit-title
      title="违纪处理记录"
      id-key="DisciplineViolationId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <div style="margin-bottom:5px;">处理明细</div>
            <el-table :data="tableData" border class="record_table">
              <el-table-column prop="FullName" label="姓名" min-width="60" />
              <el-table-column prop="Grade" label="年级" />
              <el-table-column prop="Class" label="班级" />
              <el-table-column prop="Dormitory" label="宿舍号" min-width="70"/>
              <el-table-column prop="DisciplinePoint" label="处理前周期分值" min-width="100" />
              <el-table-column prop="AfterPoint" width="145" label="处理后新增扣分值" />
              <!-- <el-table-column prop="StayQualification" label="留宿资格">
                <template slot-scope="{row}">
                  {{row.StayQualification==0?"取消":"正常"}}
                </template>
              </el-table-column>
              <el-table-column label="取消日期" min-width="110">
                <template slot-scope="{row}">
                  <span>{{$commonJs.toDateString(row.CancelDate)}}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="处理时间" min-width="110">
                <template slot-scope="{row}">
                  <span>{{$commonJs.toShortDatetimeString(row.HandleTime)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="HandleRemark" label="处理结果" min-width="110"/>
              <el-table-column prop="AddTeacherName" label="处理人"/>
              <el-table-column prop="FileUrl" label="附件" width="80" align="center">
                <template slot-scope="{row}">
                  <template v-if="row.FileUrl">
                    <el-button type="text" v-if="isImg(row.FileUrl)" @click="viewImg(row.FileUrl)">查看</el-button>
                    <el-button type="text" v-else @click="dl(row)">下载</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button @click="close(true)">关 闭</el-button>
      </template>
    </common-dialog>
    <el-dialog title="查看图片" :visible.sync="dialogVisible" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt />
      <div slot="footer">
        <el-button @click="dialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/attendance/disviolation").default,
      data: {
        DisciplineViolationId: 0,
      },
      tableData: [],
      dialogVisible: false,
      dialogImageUrl: "",
      isMB: this.$store.state.isMB,
      rules: {
        
      },
    };
  },
  methods: {
    onCreateOpened(data) {
      console.log("data",data)
      this.loading(true);
      this.api.list({ TermId: data.TermId, StudentId: data.StudentId }).then(res => {
        this.loading(false);
        if(res.Code == 0) {
          this.tableData = res.Data;
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    onEditOpened() {
    },
   
    onBeforeSave(data) {
      
      return false;
    },
    viewImg(url) {
      this.dialogImageUrl = '/api' + url;
      this.dialogVisible = true;
    },
    dl(item) {
      // window.open('/api'+item.FileUrl);
      const elink = document.createElement("a");
      elink.download = item.FileName||item.FileUrl.split("/")[4];
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = location.origin + "/api" + item.FileUrl;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    isImg(url) {
      var ex = url.split(".")[1];
      return ex=='jpg'||ex=='png'||ex=='jpeg';
    },
    onClosed() {
      this.tableData = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.record_table {
  /deep/ .el-table__body-wrapper {
    max-height: 400px;
    overflow-y: auto;
  }
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 4px;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: inset 0 0 5px rgba(150, 150, 150, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: inset 0 0 5px rgba(150, 150, 150, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>